module.exports = __webpack_public_path__ + "img/penqi.b797922b.png";